import "./asistencia.css";
import React, { useState, useEffect } from "react";
import { Button, Alert, Modal, Form, Spinner } from "react-bootstrap";
import useFetchCsrfToken from "../0. Utilidades/useFetchCsrfToken";

function RegistrarAsistencia() {
  const [cursos, setCursos] = useState([]);
  const [selectedCurso, setSelectedCurso] = useState("");
  const [fecha, setFecha] = useState("");
  const [minFecha, setMinFecha] = useState("");
  const [selectedMaestras, setSelectedMaestras] = useState([]);
  const [showMaestrasModal, setShowMaestrasModal] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Internal loading state

  const csrfToken = useFetchCsrfToken();

  useEffect(() => {
    const fetchCursos = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/perfiles/cursos/?activos=true`,
        );
        const data = await response.json();
        setCursos(data);
      } catch (error) {
        console.error("Error fetching cursos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCursos();
  }, []); // Fetch only once on mount

  const handleCursoChange = (e) => {
    const selectedId = e.target.value;
    setSelectedCurso(selectedId);

    const selectedCursoData = cursos.find(
      (curso) => curso.id === parseInt(selectedId),
    );
    if (selectedCursoData) {
      // Set `f_inicio` as `minFecha` for the date picker
      setMinFecha(selectedCursoData.f_inicio);
      setFecha("");
      setSelectedMaestras([]);
    } else {
      setMinFecha("");
    }
  };

  const handleAsistenciaSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            curso: selectedCurso,
            fecha: fecha,
            maestras_asistentes: selectedMaestras,
          }),
          credentials: "include",
        },
      );

      if (response.ok) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 5000);
        setFecha("");
        setSelectedMaestras([]);
      } else {
        console.error("Error submitting asistencia:", await response.text());
      }
    } catch (error) {
      console.error("Error submitting asistencia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMaestraSelection = (maestraId) => {
    setSelectedMaestras((prevSelected) =>
      prevSelected.includes(maestraId)
        ? prevSelected.filter((id) => id !== maestraId)
        : [...prevSelected, maestraId],
    );
  };

  const handleSelectAll = () => {
    const allMaestras =
      cursos
        .find((curso) => curso.id === parseInt(selectedCurso))
        ?.elegidas.map((maestra) => maestra.rut) || [];
    setSelectedMaestras(allMaestras);
  };

  const handleDeselectAll = () => {
    setSelectedMaestras([]);
  };

  return (
    <div className="capsule">
      <h5>Registrar Asistencia</h5>
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <div id="asistencia-formulario">
          {showSuccessAlert && (
            <Alert variant="success">Asistencia registrada exitosamente.</Alert>
          )}
          <div className="asistencia-registro">
            <label>Curso</label>
            <select value={selectedCurso} onChange={handleCursoChange}>
              <option value="">Seleccionar Curso</option>
              {cursos.map((curso) => (
                <option key={curso.id} value={curso.id}>
                  {curso.comuna} - {curso.nombre}
                </option>
              ))}
            </select>

            <label>Fecha</label>
            <input
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              min={minFecha} // Apply the correct min date
              disabled={!selectedCurso}
            />

            <Button
              className={
                selectedMaestras.length > 0 ? "btn-success" : "btn-primary"
              }
              onClick={() => setShowMaestrasModal(true)}
              disabled={!selectedCurso}
            >
              {selectedMaestras.length > 0
                ? "Maestras Seleccionadas"
                : "Seleccionar Maestras"}
            </Button>

            <button
              className="btn-success"
              onClick={handleAsistenciaSubmit}
              disabled={!fecha || !selectedCurso}
            >
              Registrar Asistencia
            </button>
          </div>
        </div>
      )}

      <Modal
        show={showMaestrasModal}
        onHide={() => setShowMaestrasModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Seleccionar Maestras</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="asistencia-modal-button">
            <Button variant="primary" onClick={handleSelectAll}>
              Seleccionar Todas
            </Button>
            <Button variant="secondary" onClick={handleDeselectAll}>
              Deseleccionar Todas
            </Button>
          </div>
          {cursos
            .find((curso) => curso.id === parseInt(selectedCurso))
            ?.elegidas.map((maestra) => (
              <div
                key={maestra.rut}
                className={`asistencia-modal-maestra ${
                  selectedMaestras.includes(maestra.rut) ? "selected" : ""
                }`}
                onClick={() => handleMaestraSelection(maestra.rut)} // Handle selection when clicked
              >
                <img
                  className="mini-icon"
                  src={
                    maestra.imagen ||
                    "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
                  }
                  alt={maestra.nombre}
                />
                <Form.Check
                  type="checkbox"
                  label={maestra.nombre}
                  checked={selectedMaestras.includes(maestra.rut)}
                  onChange={() => handleMaestraSelection(maestra.rut)}
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="btn btn-outline-primary"
            onClick={() => setShowMaestrasModal(false)}
          >
            Listo
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RegistrarAsistencia;
